import React, { Component } from 'react';
import { WithStoresComponentProps, WithStoresWrappedComponent } from '../../constants/common-types';
import { inject, Provider } from 'mobx-react';
import { ApiStoreModel } from '../../stores/apiStore/apiStore';
import { UsersStore } from '../../stores';

type WithUsersStoresInjectedProps<T> = WithStoresComponentProps<T> & {
    apiStore: ApiStoreModel;
};

const withUsersStores = <T extends {}>(WrappedComponent: WithStoresWrappedComponent<T>) => {
    @inject('apiStore')
    class WithUsersStores extends Component<WithStoresComponentProps<T>> {
        get injected() {
            return this.props as WithUsersStoresInjectedProps<T>;
        }
        usersStore: UsersStore;

        constructor(props: WithStoresComponentProps<T>) {
            super(props);
            const { api } = this.injected.apiStore;
            this.usersStore = new UsersStore(api);
        }

        render() {
            return (
                <Provider
                    usersStore={this.usersStore}
                >
                    <WrappedComponent {...this.props} />
                </Provider>
            );
        }
    }

    return WithUsersStores;
};

export default withUsersStores;
